/**
 * Sentry init — error tracking pro AraFit (mobile + web).
 *
 * Captura:
 *   - Erros JS nao tratados (crash do app)
 *   - Promises rejeitadas
 *   - Erros em React rendering
 *
 * NAO captura (por design):
 *   - Eventos analytics (uso `lib/analytics.ts` + tabela `usage_events`)
 *   - Performance (desabilitado pra economizar quota Free)
 *
 * Chamado uma vez no topo do `app/_layout.tsx`.
 *
 * Config:
 *   - DSN vem da env `EXPO_PUBLIC_SENTRY_DSN` (build-time, embedada no bundle).
 *     Setada em: Vercel (prod) e `.env.dev`/`.env.demo` (local).
 *     Se ausente: Sentry.init com DSN vazio = no-op (nao reporta erros, sem crash).
 */
import * as Sentry from '@sentry/react-native';

const SENTRY_DSN = process.env.EXPO_PUBLIC_SENTRY_DSN ?? '';

let initialized = false;

export function initSentry(): void {
  if (initialized) return;
  initialized = true;

  // No-op se DSN nao configurado (ex: build local sem .env)
  if (!SENTRY_DSN) {
    if (__DEV__) console.warn('[sentry] EXPO_PUBLIC_SENTRY_DSN nao configurado — Sentry desabilitado');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    // Release tag — casa com o sourcemap upload no Sentry (vide scripts/build-web.js).
    // Em web build (Vercel): short SHA do commit. Em dev local: undefined (sem sourcemap).
    release: process.env.EXPO_PUBLIC_RELEASE || undefined,
    // Sample rate de eventos de erro: 100% (capturamos tudo enquanto pre-comercial)
    sampleRate: 1.0,
    // Performance tracing: desativado (consome quota Free e nao precisa agora)
    tracesSampleRate: 0,
    // Debug logs do Sentry no console: so em dev
    debug: __DEV__,
    // Ambiente
    environment: __DEV__ ? 'development' : 'production',
    // Ignora erros conhecidos que nao queremos polluir o Sentry
    ignoreErrors: [
      'Network request failed',  // offline / wifi cai — esperado em mobile
      'AbortError',              // request cancelado pelo proprio app
    ],
  });
}

export { Sentry };
